import { Tag } from "antd";
import { colors } from "@libertify/ui/theme-v2";
import type { InsightCategory } from "../../types";

const categoryConfig: Record<
  InsightCategory,
  { label: string; backgroundColor: string; color: string }
> = {
  FollowUp: {
    label: "FOLLOW-UP",
    backgroundColor: colors.accent.tint,
    color: colors.accent.active,
  },
  Edit: { label: "EDIT", backgroundColor: "#ede9fe", color: "#6d28d9" },
  Insight: { label: "INSIGHT", backgroundColor: "#dbeafe", color: "#1d4ed8" },
};

export const InsightCategoryTag = ({
  category,
}: {
  category: InsightCategory;
}) => {
  const config = categoryConfig[category];
  return (
    <Tag
      color={config.backgroundColor}
      style={{
        color: config.color,
        borderRadius: 20,
        fontSize: 10,
        padding: "0 7px",
        fontWeight: 600,
        border: "none",
        letterSpacing: 0.04,
      }}
    >
      {config.label}
    </Tag>
  );
};
